module.exports = __webpack_public_path__ + "img/component.207a25e7.svg";